import get from 'lodash/get';
import { useSelector } from 'react-redux';

import { selectGenderTypes } from '../../redux/data/selectors';
import { convertGenderList } from '../../utils/converters/convertListWithLocalization';

const useGenderOptions = formatMessage => {
  const genderList = useSelector(selectGenderTypes);

  const genderOptions = convertGenderList(genderList, formatMessage) || [];

  const getGenderTitleByValue = value => {
    const matchedGenderListItem = genderOptions.find(
      item => item.value === value,
    );

    return get(matchedGenderListItem, 'label', null);
  };

  return { getGenderTitleByValue, genderOptions };
};

export default useGenderOptions;



// WEBPACK FOOTER //
// ./src/hooks/selectOptions/useGenderOptions.js